import { usePortalContext } from '@/contexts/PortalProvider';
import BookTripSupport from '@/components/member/reservation/BookTripSupport';
import { Box, styled } from '@mui/material';
import PassengerBenefits from '@/components/home/passengers/PassengerBenefits';
import { UseFormReturn } from 'react-hook-form';
import {
  ReservationFormInput,
  ReservationFormValues,
} from './schema/reservationForm.schema';
import { PassengerClientData } from '@/data/models/passenger-client-data.model';

const PREFIX = 'ReservationTripLegAside';

const classes = {
  benefits: `${PREFIX}-benefits`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.benefits}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    ['@media (min-width: 768px)']: {
      width: 320,
      flexShrink: 0,
    },
  },
}));

const ReservationTripLegAside = ({
  form,
  passengerClientData,
}: {
  form: UseFormReturn<ReservationFormInput, unknown, ReservationFormValues>;
  passengerClientData: PassengerClientData;
}) => {
  const { isMemberPortal } = usePortalContext();

  return (
    <>
      {isMemberPortal ? (
        <BookTripSupport />
      ) : (
        <StyledBox className={classes.benefits}>
          <PassengerBenefits
            appointmentDateTime={
              form.getValues('trips.0.appointmentDateTime') ?? undefined
            }
            servicePlans={passengerClientData?.servicePlans || []}
          />
        </StyledBox>
      )}
    </>
  );
};

export { ReservationTripLegAside };
